"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IBPayCardUserSchema = void 0;
var _api = require("@whitbread-eos/api");
var _zod = require("zod");
var IBPayCardUserSchema = t => {
  var schema = _zod.z.object({
    user: _zod.z.string(),
    cardDisplayNameOption: _zod.z.object({
      displayValue: _zod.z.string(),
      value: _zod.z.string()
    }),
    cardDisplayName: _zod.z.string().optional(),
    employeeId: _zod.z.string(),
    tetheredGuid: _zod.z.string(),
    schemeCustomerId: _zod.z.number(),
    schemeCountry: _zod.z.string(),
    apiUserGuid: _zod.z.string()
  });
  var validation = (data, setError, clearErrors) => {
    if (data.cardDisplayNameOption.value === _api.cardDisplayNameOptions.custom && !(data.cardDisplayName && data.cardDisplayName.length >= 1 && data.cardDisplayName.length <= 30)) {
      setError('cardDisplayName', {
        type: 'manual',
        message: t('cards.cardMgmt.addCard.displayName.typeName.error')
      });
      return false;
    }
    clearErrors('cardDisplayName');
    return true;
  };
  return {
    schema,
    validation
  };
};
exports.IBPayCardUserSchema = IBPayCardUserSchema;